import "bootstrap/js/dist/collapse";

window.am = window.am || {};

window.am.loginLayer = new function () {
    var that = this;

    this.loginLayerResizeHandler = function () {
        var loginLayer = document.getElementById('metanavloginLayer-collapse');

        if (loginLayer == null) {
            return;
        }

        var loginLayerParent = loginLayer.parentElement;
        var loginLayerWidth = Number.parseInt(window.getComputedStyle(loginLayer).width);
        var isDesktopNavigation = document.body.classList.contains('desktop');

        var parentOffset = loginLayerParent.getBoundingClientRect();
        var layerOffset = $('body').innerWidth() - parentOffset.left - loginLayerWidth;
        if (layerOffset < 0 && isDesktopNavigation) {
            loginLayer.style.left = layerOffset + 'px';
        } else {
            loginLayer.style.left = '';
        }
    };

    this.init = function () {
        window.addEventListener('resize', that.loginLayerResizeHandler);

        that.loginLayerResizeHandler();
    };
}

window.am.loginLayer.init();